import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Image,
  Row,
  Modal,
  Carousel,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { IMAGES } from "../../../assets/images/images";
import { Link } from "react-router-dom";
import CustomRadioButton from "../../../components/customcomponents/customradiobutton/CustomRadioButton";
import ReactSlider from "react-slider";
import SliderCategory from "../../../components/customcomponents/SliderCategory";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { getDashboardData } from "../../../utility/apiServices/userServices";
import { iconMap } from "../../../utility/local/constants";
import { aminitiesIcon } from "../../../utility/local/constants";
import { useNavigate } from "react-router-dom";
import LoaderHome from "../../../components/loader/homeloader";
import { addWishlist } from "../../../utility/apiServices/userServices";
import "./home.scss";
import {
  Autocomplete,
  GoogleMap,
  Marker,
  InfoWindow,
  InfoWindowF,
} from "@react-google-maps/api";
import { useGoogleMapsLoader } from "../../../utility/googleApiLoader";
import {
  facilitiesTypes,
  propertyTypesHomeFilter as getPropertyListing,
} from "../../../utility/apiServices/propertiesServices";
import { isAuthenticated, isUser } from "../../../utility/auth";
import { useDispatch } from "react-redux";
import { setPropertyCategories } from "../../../redux/frontend/CommonHelperSlice";
import { FilterContext } from "../../../utility/globle/providers/store/filterContext";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import {
  description,
  formatRating,
  getPriceBasedOnDay,
} from "../../../utility/local/functions/crypto";
import { dashboard } from "../../../utility/local/config/api_paths";
import { set } from "date-fns";
import { useTranslation } from "react-i18next";
const MAX_VISIBLE_IMAGES = 3;

const libraries = ["places"];
const HomeScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const [propertyTypes, setpropertyTypes] = useState([]);
  const [propertyData, setpropertyData] = useState([]);
  const [totalPage, settotalPage] = useState(0);
  const [dataLoading, setdataLoading] = useState(true);
  const [sortBy, setsortBy] = useState("ASC");
  const [page, setpage] = useState(1);
  const [isloadMoreData, setisloadMoreData] = useState(1);
  const [filterchangesValues, setfilterchangesValues] = useState();
  const [isPlaceSelected, setIsPlaceSelected] = useState(false);
  const [selectedAddress, setselectedAddress] = useState("");
  const [showmap, setshowmap] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [filterList, setFilterList] = useState([]);
  const { filterValues, setFilterValues, resetFilters } =
    useContext(FilterContext);
  const [maxPrice, setMaxPrice] = useState({});
  const [showDateRange, setShowDateRange] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow1, setModalShow1] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);
  const [showFilterPropertyType, setShowFilterPropertyType] = useState(false);
  const autocompleteRef = useRef(null);
  const language = localStorage.getItem("language");
  const [searchResult, setSearchResult] = useState("");
  const [startMobileSearch, setStartMobileSearch] = useState(false);
  const [state, setState] = useState({
    facilitiesTypes: [],
  });

  const currentLanguage = i18n.language;
  const handleState = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };
  let i = 0;

  const dashboardData = async (pageNumber) => {
    i++; // Increment on every function call
    if (filterValues?.userLat && filterValues?.userLon) {
      setshowmap(true);
      setmapcenter({
        lat: filterValues?.userLat,
        lng: filterValues?.userLon,
      });
    } else {
      setshowmap(false);
    }

    let filters = {
      checkInDate: (showDateRange && selectionRange.startDate) || null,
      checkOutDate: (showDateRange && selectionRange.endDate) || null,
      propertyType: filterValues.propertyType,
      facilities: filterValues.facilities,
      bedrooms: filterValues.bedrooms,
      // bathrooms: filterValues.bathrooms,
      guests: filterValues.guests.adults,
      children: filterValues.guests.children,
      pets: filterValues.guests.pets,
      minPrice: filterValues.priceRange[0],
      maxPrice: filterValues.priceRange[1],
      rating: filterValues.rating,
      userLat: filterValues?.userLat,
      userLon: filterValues?.userLon,
    };

    let response = await getDashboardData({
      sort: sortBy,
      page: pageNumber,
      filters,
    });

    if (response?.status) {
      if (pageNumber == 1) {
        setpropertyData(response?.result?.properties);
      } else {
        setpropertyData([...propertyData, ...response?.result?.properties]);
      }
      setpropertyTypes(response?.result?.propertyTypeCounts);
      if (response?.result?.propertyTypeCounts) {
        dispatch(setPropertyCategories(response?.result?.propertyTypeCounts));
      }
      settotalPage(response?.result?.totalPages);
    } else {
      console.error('Response status is false or missing');
    }

    setisloadMoreData(false);
    setdataLoading(false);
  };

  const showFilterType = () => {
    setShowFilterPropertyType(false);
  };

  const getPropertyTypes = async () => {
    try {
      const result = await getPropertyListing();
      if (result?.data) {
        setMaxPrice(result?.data.prices);
        setFilterList(result?.data?.results);
      }
    } catch (error) {
      console.error(error, "Check the error while getting types");
    }
  };

  const getFacilitiesTypes = async () => {
    try {
      const result = await facilitiesTypes();
      handleState("facilitiesTypes", result.data);
    } catch (error) {
      console.error(error, "Check the error while getting types");
    }
  };

  useEffect(() => {
    getFacilitiesTypes();
    getPropertyTypes();
  }, []);

  const containerStyle = {
    width: "100%",
    height: "100%",
  };
  const [mapcenter, setmapcenter] = useState({
    lat: 30.642751,
    lng: 76.7537301,
  });
  const handleMarkerClick = useCallback((property) => {
    setSelectedProperty(property);
  }, []);

  const reserFilters = () => {
    setFilterValues({
      mobileLat: 0,
      propertyType: "",
      facilities: [],
      areas: "",
      bedrooms: "",
      bathrooms: "",
      guests: {
        adults: 1,
        children: 0,
        pets: 0,
      },
      userLat: 0,
      userLon: 0,
      priceRange: ["", ""],
      rating: 0,
    });
  };
  const handleFilterChange = (key, value, refreshdata) => {
    setFilterValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
    if (refreshdata) {
      setfilterchangesValues((prevValues) => ({
        ...prevValues,
        [key]: value,
      }));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!modalShow) {
      setdataLoading(true);
      setpropertyData([]);
      dashboardData(1);
    }
  }, [filterValues?.propertyType]);

  const handleGuestChange = (key, value) => {
    if (value < 0) return;
    setFilterValues((prevValues) => ({
      ...prevValues,
      guests: {
        ...prevValues.guests,
        [key]: value,
      },
    }));
  };

  useEffect(() => {
    if (!sortBy) return;
    setpage(1);
    dashboardData(page);
    setdataLoading(true);
  }, [sortBy]);

  const loadMoreData = async () => {
    setisloadMoreData(true);
    await dashboardData(page + 1);
    setpage(page + 1);
  };

  const addTowishlist = async (propertyId) => {
    if (!propertyId) return;
    setHeartSelect((prevState) => ({
      ...prevState,
      [propertyId]: !prevState[propertyId],
    }));
    let response = await addWishlist({ propertyId });
    if (response?.status) {
      if (response?.isRemoved) {
        setHeartSelect((prevState) => ({
          ...prevState,
          [propertyId]: false,
        }));

        setpropertyData((prevState) =>
          prevState.map((property) =>
            property.id === propertyId
              ? { ...property, iswishlisted: false }
              : property
          )
        );
      } else if (response?.isAdded) {
        setHeartSelect((prevState) => ({
          ...prevState,
          [propertyId]: true,
        }));

        setpropertyData((prevState) =>
          prevState.map((property) =>
            property.id === propertyId
              ? {
                ...property,
                iswishlisted: true,
              }
              : property
          )
        );
      }
    } else {
      setHeartSelect((prevState) => ({
        ...prevState,
        [propertyId]: !prevState[propertyId],
      }));
    }
  };

  const items = propertyTypes.map((property) => {
    return {
      name: property.property_type_id,
      icon: iconMap[property.property_type_id] || null,
      badgeCount: property.count,
    };
  });

  const [heartSelect, setHeartSelect] = useState({});
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const toggleHeart = (id) => {
    setHeartSelect((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const dateRangePickerRef = useRef();

  const handleSelect = (ranges) => {
    setShowDateRange(true);
    setSelectionRange(ranges.selection);
  };

  const handleClickOutside = (event) => {
    if (
      dateRangePickerRef.current &&
      !dateRangePickerRef.current.contains(event.target)
    ) {
      setShowDateRangePicker(false);
    }
  };

  useEffect(() => {
    if (showDateRangePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDateRangePicker]);

  useEffect(() => {
    if (startMobileSearch) {
      setdataLoading(true);
      setpropertyData([]);
      const fetchData = async () => {
        try {
          await dashboardData(1);
        } catch (error) {
          console.error("Error fetching dashboard data:", error);
        } finally {
          setdataLoading(false);
        }
      };

      fetchData();
    }
  }, [startMobileSearch]);


  const { isLoaded, loadError } = useGoogleMapsLoader();

  if (loadError) {
    console.error("Google Maps load error:", loadError);
    return <div>Error loading Google Maps</div>;
  }

  const handlePlaceSelected = () => {
    const place = autocompleteRef.current.getPlace();
    if (place && place.formatted_address) {
      const geometry = place.geometry;
      setFilterValues((prevValues) => ({
        ...prevValues,
        userLat: geometry.location.lat(),
        userLon: geometry.location.lng(),
      }));
      setselectedAddress(place.formatted_address);
      setIsPlaceSelected(true);
    }
  };

  const handleInputBlur = () => {
    if (!isPlaceSelected) {
      setFilterValues((prevValues) => ({
        ...prevValues,
        location: "",
      }));
    }
  };

  if (!isLoaded) {
    return null;
  }

  function onLoad(autocomplete) {
    setSearchResult(autocomplete);
  }
  const resetPage = async () => {
    const pageNumber = 1;
    let filters = {
      checkInDate: null,
      checkOutDate: null,
      propertyType: null,
      facilities: [],
      bedrooms: [],
      guests: 0,
      children: 0,
      pets: 0,
      minPrice: "",
      maxPrice: "",
      rating: 0,
      userLat: 0,
      userLon: 0,
    };

    let response = await getDashboardData({
      sort: sortBy,
      page: pageNumber,
      filters,
    });

    if (response?.status) {
      if (pageNumber == 1) {
        setpropertyData(response?.result?.properties);
      } else {
        setpropertyData([...propertyData, ...response?.result?.properties]);
      }
      setpropertyTypes(response?.result?.propertyTypeCounts);
      if (response?.result?.propertyTypeCounts) {
        dispatch(setPropertyCategories(response?.result?.propertyTypeCounts));
      }
      settotalPage(response?.result?.totalPages);
    }
    setisloadMoreData(false);
    setdataLoading(false);
  };

  function onPlaceChanged() {
    if (searchResult != null) {
      const place = searchResult.getPlace();
      const formattedAddress = place.formatted_address;
      const geometry = place.geometry;
      if (geometry) {
        const lat = geometry.location.lat();
        const lng = geometry.location.lng();
        handlePlaceSelectedMobile(formattedAddress, lat, lng);
      }
    } else {
      alert("Please enter text");
    }
  }

  const handlePlaceSelectedMobile = (formattedAddress, lat, lng) => {
    if (formattedAddress) {
      setFilterValues((prevValues) => ({
        ...prevValues,
        userLat: lat,
        userLon: lng,
      }));
      setselectedAddress(formattedAddress);
      setIsPlaceSelected(true);
      setStartMobileSearch(true);
    }
  };

  return (
    <React.Fragment>
      <section className="commonpad commonpadMob">
        <Container fluid>
          <Row
            className="mobileSearch "
            style={{ margin: "10px 0px 10px  0px" }}
          >
            <div
              className={
                currentLanguage === "he"
                  ? "rtlSearch homeSearch "
                  : "homeSearch"
              }
            >
              <Form.Group>
                <Icon
                  icon="ri:search-line"
                  className="searchIcon"
                  fontSize={23}
                  color={"#000000"}
                />
                <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}>
                  <input
                    type="text"
                    placeholder={t("searchBar.enterLocation")}
                    className="me-3 form-control"
                  />
                </Autocomplete>
              </Form.Group>

              <Button
                variant="primary"
                style={{ minWidth: 54 }}
                onClick={() => setModalShow1(true)}
              >
                <Icon icon="mage:filter" fontSize={25} color={"#000000"} />
              </Button>

              <Button
                variant="primary"
                style={{ minWidth: 54 }}
                onClick={() => {
                  resetFilters();
                  resetPage();
                  setShowFilterPropertyType(true);
                }}
              >
                <Icon
                  icon="carbon:filter-reset"
                  fontSize={25}
                  color={"#1d91bf"}
                />
              </Button>
            </div>
          </Row>

          <Row className="hideMobileFilter">
            <Col md={12}>
              <div className="filterBox">
                <Form.Group
                  className={
                    language === "he"
                      ? "rBorder-rtl rBorder p-3"
                      : "rBorder p-0"
                  }
                >
                  <Form.Label>{t("searchBar.location")}</Form.Label>
                  <Autocomplete
                    className={currentLanguage === "he" ? "me-0" : "me-3"}
                    onLoad={(autocomplete) => {
                      autocompleteRef.current = autocomplete;
                    }}
                    onLoadError={(error) => {
                      console.error("Autocomplete failed to load:", error);
                    }}
                    onPlaceChanged={() => {
                      handlePlaceSelected();
                    }}
                    fields={["formatted_address", "geometry"]}
                  >
                    <Form.Control
                      type="text"
                      placeholder={t("searchBar.enterLocation")}
                      onBlur={handleInputBlur}
                      defaultValue={selectedAddress}
                      // onChange={() => {
                      onChange={(e) => {
                        if (!e.target.value) {
                          setFilterValues((prevValues) => ({
                            ...prevValues,
                            userLat: 0,
                            userLon: 0,
                          }));
                        }
                      }}
                    />
                  </Autocomplete>
                </Form.Group>

                <Form.Group
                  className={
                    language === "he" ? "rBorder-rtl rBorder" : "rBorder"
                  }
                >
                  <Form.Label>{t("searchBar.checkIn")}</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle
                      id="check-in"
                      onClick={() => {
                        setShowDateRangePicker(!showDateRangePicker);
                        // console.log(!showDateRangePicker)
                      }}
                    >
                      <Icon
                        icon="clarity:date-line"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      {(showDateRange &&
                        selectionRange.startDate &&
                        selectionRange.startDate.toDateString()) ||
                        t("searchBar.datePlaceholder")}
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                    {showDateRangePicker && (
                      <div
                        className="date-range-container date-range-positionabs"
                        ref={dateRangePickerRef}
                      >
                        <DateRangePicker
                          ranges={[selectionRange]}
                          minDate={new Date()}
                          months={2}
                          onChange={handleSelect}
                          direction="horizontal"
                          moveRangeOnFirstSelection={false}
                        />
                      </div>
                    )}
                  </Dropdown>
                </Form.Group>

                <Form.Group
                  className={
                    language === "he" ? "rBorder-rtl rBorder" : "rBorder"
                  }
                >
                  <Form.Label>{t("searchBar.checkOut")}</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle
                      id="check-out"
                      onClick={() =>
                        setShowDateRangePicker(!showDateRangePicker)
                      }
                    >
                      <Icon
                        icon="clarity:date-line"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      {(showDateRange &&
                        selectionRange.endDate &&
                        selectionRange.endDate.toDateString()) ||
                        "DD / MM / YYYY"}
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                  </Dropdown>
                </Form.Group>

                <Form.Group
                  className={
                    language === "he" ? "rBorder-rtl rBorder" : "rBorder"
                  }
                >
                  <Form.Label>{t("searchBar.guest")}</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle id="location" className="text-start">
                      <Icon
                        icon="ic:baseline-people"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      {filterValues?.guests?.adults > 0 &&
                        filterValues?.guests?.adults + " adults,"}{" "}
                      {filterValues?.guests?.children > 0 &&
                        filterValues?.guests?.children + " children, "}
                      {filterValues?.guests?.pets > 0 &&
                        filterValues?.guests?.pets + " pets"}
                      {/* 3 adults, <br />3 children,2 pets */}
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="quantityBox">
                      <Dropdown.Item>
                        <div>
                          <span>{t("searchBar.guest")}</span>
                          <div className="pro_counter">
                            <div className="icon_Pro">
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGuestChange(
                                    "adults",
                                    filterValues?.guests?.adults - 1
                                  );
                                }}
                                color="#000000"
                                icon="clarity:minus-line"
                              />
                            </div>
                            <span>{filterValues?.guests?.adults}</span>
                            <div className="icon_Pro">
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGuestChange(
                                    "adults",
                                    filterValues?.guests?.adults + 1
                                  );
                                }}
                                color="#000000"
                                icon="basil:plus-outline"
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <span>{t("searchBar.children")}</span>
                          <div className="pro_counter">
                            <div className="icon_Pro">
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGuestChange(
                                    "children",
                                    filterValues.guests.children - 1
                                  );
                                }}
                                color="#000000"
                                icon="clarity:minus-line"
                              />
                            </div>
                            <span>{filterValues?.guests?.children}</span>
                            <div className="icon_Pro">
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGuestChange(
                                    "children",
                                    filterValues.guests.children + 1
                                  );
                                }}
                                color="#000000"
                                icon="basil:plus-outline"
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <span>{t("searchBar.pets")}</span>
                          <div className="pro_counter">
                            <div className="icon_Pro">
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGuestChange(
                                    "pets",
                                    filterValues?.guests?.pets - 1
                                  );
                                }}
                                color="#000000"
                                icon="clarity:minus-line"
                              />
                            </div>
                            <span>{filterValues?.guests?.pets}</span>
                            <div className="icon_Pro">
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGuestChange(
                                    "pets",
                                    filterValues?.guests?.pets + 1
                                  );
                                }}
                                color="#000000"
                                icon="basil:plus-outline"
                              />
                            </div>
                          </div>
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <Form.Group
                  className="filterLink"
                  onClick={() => setModalShow(true)}
                >
                  <Image src={IMAGES.Filter} alt="" />
                  <h4>{t("searchBar.advanced")}</h4>
                </Form.Group>
                <div>
                  <Button
                    variant="primary"
                    onClick={() => {
                      setdataLoading(true);
                      setpropertyData([]);
                      dashboardData(1);
                    }}
                  >
                    <Icon
                      icon="iconoir:search"
                      fontSize={25}
                      color={"#ffffff"}
                      className="me-2"
                    />
                    {t("searchBar.search")}
                  </Button>

                  <div className="icon-container">
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        window.location.reload("/");
                        setShowFilterPropertyType(true);
                        resetPage();
                        resetFilters();
                      }}
                    >
                      <Icon
                        color="#000000"
                        icon="carbon:filter-reset"
                        fontSize={18}
                      />
                      <span className="tooltip-text">
                        {t("searchBar.resetFilters")}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {!showFilterPropertyType && (
            <Row>
              <Col md={12}>
                <div
                  className={
                    currentLanguage === "he"
                      ? "rtlSlider sliderCatPad"
                      : "sliderCatPad"
                  }
                >
                  <SliderCategory
                    handleFilterChange={handleFilterChange}
                    selectedPropertyTypes={filterValues?.propertyType}
                    items={filterList || []}
                  />
                </div>
              </Col>
            </Row>
          )}

          <Row className="mb-4 sortByMobile">
            <Col md={12}>
              <div className="sortBy">
                <span>{t("home.sortBy")}</span>
                <Form.Select
                  className={
                    currentLanguage === "he" ? "rtl-dropdown" : "ltr-dropdown"
                  }
                  onChange={(e) => {
                    setpropertyData([]);
                    setsortBy(e.target.value);
                  }}
                >
                  <option value={"ASC"}>{t("home.priceLowToHigh")}</option>
                  <option value={"DESC"}>{t("home.priceHighToLow")}</option>
                </Form.Select>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={showmap && propertyData ? 7 : 12}>
              <Row className={showmap ? "showscrollproperties" : ""}>
                {dataLoading ? (
                  <>
                    <div className="text-center d-flex justify-content-center">
                      <LoaderHome />
                    </div>
                  </>
                ) : (
                  <>
                    {propertyData?.length ? (
                      <>
                        {propertyData?.map((listing) => (
                          <Col
                            key={listing?.id}
                            xl={showmap && propertyData ? 4 : 3}
                            lg={showmap && propertyData ? 4 : 4}
                            md={6}
                          >
                            <div className="listing listing1" onClick={() => navigate("property-detail", { state: { data: listing } })} style={{ cursor: 'pointer' }}>
                              <div className="listImgBox">
                                <div className="starRating">
                                  <Icon icon="ph:star-fill" />
                                  {listing?.averageRating
                                    ? formatRating(listing?.averageRating)
                                    : 0}
                                </div>
                                {isAuthenticated() && isUser() && (
                                  <div
                                    className="heartBox"
                                    onClick={(e) => { e.stopPropagation(); addTowishlist(listing?.id); }}
                                  >
                                    {heartSelect[listing?.id] ||
                                      listing?.isWishlisted ? (
                                      <Icon
                                        icon="ph:heart-fill"
                                        color="#ffffff"
                                      />
                                    ) : (
                                      <Icon icon="ph:heart-light" />
                                    )}
                                  </div>
                                )}
                              </div>
                              <Carousel data-bs-theme="dark" interval={null}>
                                {(() => {
                                  const flatImages = (Array.isArray(listing?.images) ? listing.images.flatMap(item => {
                                    if (typeof item === 'string') return item;
                                    if (typeof item === 'object' && item !== null) return Object.values(item).flatMap(v => Array.isArray(v) ? v.map(k => k?.location || k) : []);
                                    return [];
                                  }) : []);

                                  if (flatImages.length === 0) {
                                    return (
                                      <Carousel.Item>
                                        <div className="listImage" style={{ backgroundColor: '#f0f0f0', backgroundImage: `url(${IMAGES.PlaceHolderImage})` }}></div>
                                      </Carousel.Item>
                                    )
                                  }

                                  return flatImages.map((image, index) => (
                                    <Carousel.Item key={index}>
                                      <div
                                        className="listImage"
                                        style={{
                                          backgroundImage: `url(${image})`,
                                        }}
                                      ></div>
                                    </Carousel.Item>
                                  ));
                                })()}
                              </Carousel>
                              <div className="listing_body">
                                <div className="listing_body_pad">
                                  <h2>
                                    {/* {`${
                                      listing?.short_description?.length > 35
                                        ? listing?.short_description?.slice(
                                            0,
                                            35
                                          ) + "..."
                                        : listing?.short_description
                                    }`} */}
                                    {description(
                                      listing?.short_description,
                                      listing?.short_description_hebrew,
                                      currentLanguage
                                    )}
                                  </h2>
                                  <h3>
                                    <Icon icon="system-uicons:location" />{" "}
                                    {`${listing?.street_address?.length > 30
                                      ? listing?.street_address?.slice(
                                        0,
                                        30
                                      ) + "..."
                                      : listing?.street_address
                                      }`}
                                  </h3>
                                  <div
                                    className="listing_iconFlex"
                                    style={{
                                      flex: "flex",
                                      flexWrap: "wrap",
                                      margin: "1px 1px 0px 0px",
                                    }}
                                  >
                                    {listing?.facilities?.map((val, index) => (
                                      <>
                                        {index < MAX_VISIBLE_IMAGES && (
                                          <Icon
                                            key={index}
                                            className="cardIconImages"
                                            icon={aminitiesIcon[val]}
                                            width={25}
                                            height={25}
                                            color="#1b91bf"
                                            style={{
                                              marginRight: "5px",
                                            }}
                                          />
                                        )}
                                      </>
                                    ))}

                                    {listing?.facilities?.length >
                                      MAX_VISIBLE_IMAGES && (
                                        <span className="moreText">
                                          +
                                          {listing?.facilities?.length -
                                            MAX_VISIBLE_IMAGES}
                                        </span>
                                      )}
                                  </div>
                                </div>
                                <div className="listing_body_pad listing_body_footer">
                                  {/* <h5>${listing?.price_for_weekdays}</h5> */}
                                  <h5>
                                    $
                                    {getPriceBasedOnDay(
                                      listing?.weekdays_discounted_price,
                                      listing?.weekend_discounted_price
                                    )}{" "}
                                  </h5>

                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                        <div className="d-flex align-items-center justify-content-center mt-3">
                          {totalPage > page &&
                            showmap &&
                            propertyData.length > 0 && (
                              <Button
                                onClick={() => {
                                  loadMoreData();
                                }}
                                variant="primary"
                                className="px-5"
                              >
                                {isloadMoreData ? (
                                  <span className="spinner-light"></span>
                                ) : (
                                  t("viewMore")
                                )}
                              </Button>
                            )}
                        </div>
                      </>
                    ) : (
                      <div className="text-center">{t("home.noResults")}</div>
                    )}
                  </>
                )}
              </Row>
            </Col>
            {showmap && propertyData && (
              <Col lg={5} style={{ height: "1000px" }}>
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={mapcenter}
                  zoom={10}
                >
                  {propertyData.map((property, index) => (
                    <Marker
                      key={index}
                      position={{
                        lat: property.latitude + index * 0.0001,
                        lng: property.longitude + index * 0.0001,
                      }}
                      onClick={() => handleMarkerClick(property)}
                      icon={{
                        url: IMAGES.MapPin,
                        scaledSize: new window.google.maps.Size(50, 50),
                      }}
                    />
                  ))}
                  {selectedProperty ? (
                    <div className="Cusotmmajdnaj">
                      <InfoWindowF
                        position={{
                          lat: selectedProperty.latitude,
                          lng: selectedProperty.longitude,
                        }}
                        onCloseClick={() => {
                          setSelectedProperty(null);
                        }}
                        options={{
                          disableAutoPan: true,
                          closeBoxURL: "",
                          pixelOffset: new window.google.maps.Size(0, -10),
                        }}
                      >
                        <div className="listing listingMap">
                          <div className="listImgBox">
                            <div className="starRating">
                              <Icon icon="ph:star-fill" />
                              {selectedProperty?.averageRating
                                ? formatRating(selectedProperty?.averageRating)
                                : 0}
                            </div>
                            <div>
                              {/* {isAuthenticated() && (
                                <div
                                  className="heartBox"
                                  style={{ marginRight: 20 }}
                                  onClick={() =>
                                    addTowishlist(selectedProperty?.id)
                                  }
                                >
                                  {heartSelect[selectedProperty?.id] ||
                                    selectedProperty?.iswishlisted ? (
                                    <Icon
                                      icon="ph:heart-fill"
                                      color="#ffffff"
                                    />
                                  ) : (
                                    <Icon icon="ph:heart-light" />
                                  )}
                                </div>
                              )} */}
                              <div
                                className="closeButton"
                                onClick={() => setSelectedProperty(null)}
                                style={{
                                  position: "absolute",
                                  top: "8px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Icon
                                  icon="carbon:close-outline"
                                  fontSize={20}
                                  color="#ffffff"
                                />
                              </div>
                            </div>
                          </div>
                          <Carousel data-bs-theme="dark">
                            {(() => {
                              const flatImages = (Array.isArray(selectedProperty?.images) ? selectedProperty.images.flatMap(item => {
                                if (typeof item === 'string') return item;
                                if (typeof item === 'object' && item !== null) return Object.values(item).flatMap(v => Array.isArray(v) ? v.map(k => k?.location || k) : []);
                                return [];
                              }) : []);

                              if (flatImages.length === 0) {
                                return (
                                  <Carousel.Item>
                                    <div className="listImage" style={{ backgroundColor: '#f0f0f0', backgroundImage: `url(${IMAGES.PlaceHolderImage})` }}></div>
                                  </Carousel.Item>
                                );
                              }

                              return flatImages.map((image, index) => (
                                <Carousel.Item key={index}>
                                  <div
                                    className="listImage"
                                    style={{
                                      backgroundImage: `url(${image})`,
                                    }}
                                  ></div>
                                </Carousel.Item>
                              ));
                            })()}
                          </Carousel>

                          <div className="listing_body">
                            <div className="listing_body_pad">
                              <h2>
                                {`${selectedProperty?.short_description?.length >
                                  45
                                  ? selectedProperty?.short_description?.slice(
                                    0,
                                    45
                                  ) + "..."
                                  : selectedProperty?.short_description
                                  }`}
                              </h2>
                              <h3>
                                <Icon icon="system-uicons:location" />{" "}
                                {`${selectedProperty?.street_address?.length > 40
                                  ? selectedProperty?.street_address?.slice(
                                    0,
                                    40
                                  ) + "..."
                                  : selectedProperty?.street_address
                                  }`}
                              </h3>
                              <div className="listing_iconFlex">
                                {selectedProperty?.facilities
                                  ?.slice(0, 3)
                                  .map((amenity, index) => (
                                    <Icon
                                      key={index}
                                      icon={aminitiesIcon[amenity]}
                                    />
                                  ))}
                                {selectedProperty?.facilities?.length > 3 && (
                                  <span>
                                    +{selectedProperty.facilities.length - 3}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="listing_body_pad listing_body_footer">
                              <h5>
                                {" "}
                                $
                                {getPriceBasedOnDay(
                                  selectedProperty?.weekdays_discounted_price,
                                  selectedProperty?.weekend_discounted_price
                                )}{" "}
                              </h5>
                              <Button
                                variant="outline-primary"
                                onClick={() => {
                                  navigate("property-detail", {
                                    state: {
                                      data: selectedProperty,
                                    },
                                  });
                                }}
                              >
                                {t("home.showMore")}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </InfoWindowF>
                    </div>
                  ) : (
                    <></>
                  )}
                </GoogleMap>
              </Col>
            )}
          </Row>

          <div className="d-flex align-items-center justify-content-center mt-3">
            {totalPage > page && !showmap && propertyData.length > 0 && (
              <Button
                onClick={() => {
                  loadMoreData();
                }}
                variant="primary"
                className="px-5"
              >
                {isloadMoreData ? (
                  <span className="spinner-light"></span>
                ) : (
                  t("viewMore")
                )}
              </Button>
            )}
          </div>
        </Container>
      </section>
      <AdvancedFilterModal
        show={modalShow}
        onHide={() => {
          setShowFilterPropertyType(true);
          setModalShow(false);
        }}
        filters={filterValues}
        handleFilterChange={handleFilterChange}
        reserFilters={reserFilters}
        setdataLoading={setdataLoading}
        setpropertyData={setpropertyData}
        dashboardData={dashboardData}
        maxPrice={maxPrice}
        showFilterType={showFilterType}
        filterList={filterList}
        facilitiesTypes={state.facilitiesTypes}
      />
      <AdvancedFilterModalMobile
        show={modalShow2}
        currentLanguage={currentLanguage}
        maxPrice={maxPrice}
        dashboardData={dashboardData}
        setShowFilterPropertyType={setShowFilterPropertyType}
        onHide={() => {
          setShowFilterPropertyType(true);
          setModalShow2(false);
        }}
        onHideMainModel={() => {
          setModalShow1(false);
        }}
        filters={filterValues}
        handleFilterChange={handleFilterChange}
        reserFilters={reserFilters}
        showFilterType={showFilterType}
        filterList={filterList}
        facilitiesTypes={state.facilitiesTypes}
      />
      <FilterModal
        currentLanguage={currentLanguage}
        show={modalShow1}
        setdataLoading={setdataLoading}
        setpropertyData={setpropertyData}
        dashboardData={dashboardData}
        onModalClick={() => setModalShow2(true)}
        onHide={() => {
          setModalShow1(false);
        }}
        filters={filterValues}
        handleFilterChange={handleFilterChange}
        reserFilters={reserFilters}
        autocompleteRef={autocompleteRef}
        selectedAddress={selectedAddress}
        handlePlaceSelected={handlePlaceSelected}
        handleInputBlur={handleInputBlur}
        setFilterValues={setFilterValues}
      />
    </React.Fragment>
  );
};

const options = [
  { label: "Any", value: "" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8+", value: "8+" },
];

function FilterModal(props) {
  const {
    filters,
    handleFilterChange,
    show,
    onHide,
    onModalClick,
    dashboardData,
    setdataLoading,
    setpropertyData,
    currentLanguage,
  } = props;

  const handleGuestsChange = (type, value) => {
    handleFilterChange("guests", {
      ...filters?.guests,
      [type]: value,
    });
  };

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const [searchPlace, setPlace] = useState(null);

  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} size="lg" className="phoneModal">
      <Modal.Body>
        <Icon
          icon="carbon:close-outline"
          fontSize={32}
          color={"#CF0000"}
          onClick={onHide}
          className={
            currentLanguage === "he" ? "crossModal rtlCrossBtn" : "crossModal"
          }
        />
        <h2 className="text-left">{t("filter.whereTo")}</h2>
        <Row>
          <Col md={12}>
            <div className="filterBox">
              <div className="borderBttom">
                <Row className="iconSize">
                  <Col xs={6} className="rBorder1">
                    <Form.Group className="rBorder">
                      <Form.Label>{t("filter.checkIn")}</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle
                          id="location"
                          onClick={() =>
                            setShowDateRangePicker(!showDateRangePicker)
                          }
                        >
                          <Icon
                            icon="ion:location-sharp"
                            fontSize={25}
                            color={"#D6D7D8"}
                          />
                          {selectionRange.startDate.toDateString()}
                          <Icon
                            icon="fluent:chevron-down-20-filled"
                            fontSize={22}
                            color={"#000000"}
                            className="chevron"
                          />
                        </Dropdown.Toggle>
                      </Dropdown>
                    </Form.Group>
                    {showDateRangePicker && (
                      <>
                        <div className="date-range-container date-range-positionabs flex-column">
                          <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={handleSelect}
                            minDate={new Date()}
                            months={2}
                            direction="vertical"
                            moveRangeOnFirstSelection={false}
                            className="dateTop"
                          />
                          <div className="p-2">
                            <button
                              className="close-btn btn btn-primary w-100"
                              onClick={() => setShowDateRangePicker(false)}
                            >
                              {t("filter.close")}
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="rBorder">
                      <Form.Label> {t("filter.checkOut")}</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle
                          id="location"
                          onClick={() =>
                            setShowDateRangePicker(!showDateRangePicker)
                          }
                        >
                          <Icon
                            icon="ion:location-sharp"
                            fontSize={25}
                            color={"#D6D7D8"}
                          />
                          {selectionRange.endDate.toDateString()}
                          <Icon
                            icon="fluent:chevron-down-20-filled"
                            fontSize={22}
                            color={"#000000"}
                            className="chevron"
                          />
                        </Dropdown.Toggle>
                      </Dropdown>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <Form.Group className="rBorder borderBttom">
                <Form.Label>{t("filter.guest")}</Form.Label>
                <Dropdown>
                  <Dropdown.Toggle
                    id="location"
                    className="text-start"
                    dir={currentLanguage === "he" ? "rtl" : "ltr"}
                  >
                    {currentLanguage === "en" && (
                      <>
                        <Icon
                          icon="ion:location-sharp"
                          fontSize={25}
                          color={"#D6D7D8"}
                        />{" "}
                        {`${filters?.guests?.adults} ${t("filter.adults")}, ${filters?.guests?.children
                          } ${t("filter.children")}, ${filters?.guests?.pets} ${t(
                            "filter.pets"
                          )}`}
                        <Icon
                          icon="fluent:chevron-down-20-filled"
                          fontSize={22}
                          color={"#000000"}
                          className="chevron"
                        />
                      </>
                    )}
                    {currentLanguage === "he" && (
                      <>
                        <Icon
                          icon="fluent:chevron-down-20-filled"
                          fontSize={22}
                          color={"#000000"}
                          className="chevron"
                        />
                        {`${filters?.guests?.adults} ${t("filter.adults")}, ${filters?.guests?.children
                          } ${t("filter.children")}, ${filters?.guests?.pets
                          }  ${t("filter.pets")}`}
                        <Icon
                          icon="ion:location-sharp"
                          fontSize={25}
                          color={"#D6D7D8"}
                        />
                      </>
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="quantityBox">
                    <Dropdown.Item>
                      <div>
                        <span>{t("filter.adults")}</span>
                        <div className="pro_counter">
                          <div className="icon_Pro">
                            <Icon
                              onClick={() =>
                                handleGuestsChange(
                                  "adults",
                                  filters?.guests?.adults - 1
                                )
                              }
                              color="#000000"
                              icon="clarity:minus-line"
                            />
                          </div>
                          <span>{filters?.guests?.adults}</span>
                          <div className="icon_Pro">
                            <Icon
                              onClick={() =>
                                handleGuestsChange(
                                  "adults",
                                  filters?.guests?.adults + 1
                                )
                              }
                              color="#000000"
                              icon="basil:plus-outline"
                            />
                          </div>
                        </div>
                      </div>

                      <div>
                        <span>{t("filter.children")}</span>
                        <div className="pro_counter">
                          <div className="icon_Pro">
                            <Icon
                              onClick={() => {
                                if (filters?.guests?.children > 0) {
                                  handleGuestsChange(
                                    "children",
                                    filters?.guests?.children - 1
                                  );
                                }
                              }}
                              color="#000000"
                              icon="clarity:minus-line"
                            />
                          </div>
                          <span>{filters?.guests?.children}</span>
                          <div className="icon_Pro">
                            <Icon
                              onClick={() =>
                                handleGuestsChange(
                                  "children",
                                  filters?.guests?.children + 1
                                )
                              }
                              color="#000000"
                              icon="basil:plus-outline"
                            />
                          </div>
                        </div>
                      </div>

                      <div>
                        <span>{t("filter.pets")}</span>
                        <div className="pro_counter">
                          <div className="icon_Pro">
                            <Icon
                              onClick={() => {
                                if (filters?.guests?.pets > 0) {
                                  handleGuestsChange(
                                    "pets",
                                    filters?.guests?.pets - 1
                                  );
                                }
                              }}
                              color="#000000"
                              icon="clarity:minus-line"
                            />
                          </div>
                          <span>{filters?.guests?.pets}</span>
                          <div className="icon_Pro">
                            <Icon
                              onClick={() =>
                                handleGuestsChange(
                                  "pets",
                                  filters?.guests?.pets + 1
                                )
                              }
                              color="#000000"
                              icon="basil:plus-outline"
                            />
                          </div>
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>

              <Link className="adFilter" onClick={onModalClick}>
                {t("filter.advancedFilter")}
              </Link>
            </div>
          </Col>
        </Row>

        <Button
          onClick={() => {
            setdataLoading(true);
            setpropertyData([]);
            dashboardData(1);
            onHide();
          }}
          className="w-100"
        >
          {t("filter.search")}
        </Button>
      </Modal.Body>
    </Modal>
  );
}

function AdvancedFilterModalMobile(props) {
  const {
    filters,
    handleFilterChange,
    show,
    onHide,
    filterList = [],
    facilitiesTypes = [],
    showFilterType,
    onHideMainModel,
    reserFilters,
    setShowFilterPropertyType,
    dashboardData,
    maxPrice,
    currentLanguage,
  } = props;
  const { t } = useTranslation();

  const handleGuestsChange = (type, value) => {
    handleFilterChange("guests", {
      ...filters.guests,
      [type]: value,
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      scrollable={true}
      aria-labelledby="contained-modal-title-vcenter modal-dialog-scrollable"
      centered
      className="phoneModal"
    >
      <Modal.Body
        tyle={{
          maxHeight: "calc(100vh - 210px)",
          overflowY: "auto",
        }}
      >
        <Icon
          icon="carbon:close-outline"
          fontSize={32}
          color={"#CF0000"}
          onClick={onHide}
          className={currentLanguage === "he" ? "rtlCrossModel" : "crossModal"}
        />
        <h2 className="text-center">{t("filter.advancedFilter")}</h2>
        <div className="modal_Header">
          <h3> {t("filter.propertyType")}</h3>
          {/* <Link className="showAll">Show All</Link> */}
        </div>
        <div className="checkBoxes">
          {filterList &&
            filterList.length > 0 &&
            filterList.map((item, index) => (
              <div key={`property-checkbox-${index}`} className="mb-3">
                <Form.Check
                  type="checkbox"
                  id={`property-checkbox-${index}`}
                  label={item.eng_title}
                  checked={filters?.propertyType?.includes(item?.id.toString())}
                  onChange={() =>
                    handleFilterChange(
                      "propertyType",
                      filters.propertyType.includes(item.id.toString())
                        ? filters.propertyType.filter(
                          (i) => i !== item.id.toString()
                        )
                        : [...filters.propertyType, item.id.toString()]
                    )
                  }
                />
              </div>
            ))}
        </div>
        <div className="modal_Header">
          <h3>{t("filter.facilities")}</h3>
          {/* <Link className="showAll">Show All</Link> */}
        </div>
        <div className="checkBoxes">
          {facilitiesTypes &&
            facilitiesTypes.length > 0 &&
            facilitiesTypes.map((item, index) => (
              <div key={`facilities-checkbox-${index}`} className="mb-3">
                <Form.Check
                  type="checkbox"
                  id={`facilities-checkbox-${index}`}
                  label={item.eng_title}
                  checked={filters?.facilities?.includes(item?.eng_title)}
                  onChange={() =>
                    handleFilterChange(
                      "facilities",
                      filters.facilities.includes(item.eng_title)
                        ? filters.facilities.filter(
                          (i) => i !== item?.eng_title
                        )
                        : [...filters.facilities, item?.eng_title]
                    )
                  }
                />
              </div>
            ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Areas/Zones/Cities</h3>
        </div>
        <Form.Control
          type="text"
          placeholder="Enter Areas/Zones/Cities"
          className="inputNormal"
          value={filters?.areas}
          onChange={(e) => handleFilterChange("areas", e.target.value)}
        ></Form.Control> */}
        <div className="modal_Header">
          <h3>{t("filter.bedrooms")}</h3>
        </div>
        <div className="radio-group">
          {options?.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option.value}
              checked={filters?.bedrooms === option.value}
              onChange={(e) => handleFilterChange("bedrooms", e.target.value)}
            />
          ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Bathrooms</h3>
        </div> */}
        {/* <div className="radio-group">
          {options1.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option?.value}
              checked={filters?.bathrooms === option?.value}
              onChange={(e) =>
                handleFilterChange("bathrooms", e?.target?.value)
              }
            />
          ))}
        </div> */}
        <div className="modal_Header">
          <h3>{t("filter.guests")}</h3>
        </div>
        <div className="quBox">
          <div>
            <span>{t("filter.adults")}</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("adults", filters.guests.adults - 1)
                  }
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{filters?.guests?.adults}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("adults", filters.guests.adults + 1)
                  }
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>{t("filter.children")}</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("children", filters.guests.children - 1)
                  }
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{filters?.guests?.children}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange(
                      "children",
                      filters?.guests?.children + 1
                    )
                  }
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>{t("filter.pets")}</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("pets", filters?.guests?.pets - 1)
                  }
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{filters?.guests?.pets}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("pets", filters?.guests?.pets + 1)
                  }
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal_Header">
          <h3>{t("filter.price")}</h3>
        </div>
        <div className="reactSliderFlex">
          <ReactSlider
            className="horizontal-slider horizontal-slider1"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            value={filters?.priceRange}
            onChange={(newValues) =>
              handleFilterChange("priceRange", newValues)
            }
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            min={1}
            max={maxPrice.price_for_weekends || 1000}
          />
        </div>
        <div className="priceRangFlex">
          <div className="rangeControl">
            <h4>{t("filter.minimum")}</h4>
            <h5>${filters?.priceRange[0]}</h5>
          </div>
          <div className="rangeDivider"></div>
          <div className="rangeControl">
            <h4>{t("filter.maximum")}</h4>
            <h5>${filters?.priceRange[1]}</h5>
          </div>
        </div>
        <div className="modal_Header">
          <h3>{t("filter.rating")}</h3>
        </div>
        <div className="star-rating">
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              className={index < filters?.rating ? "star filled" : "star"}
              onClick={() => handleFilterChange("rating", index + 1)}
            >
              <Icon icon="ph:star-fill" />
            </span>
          ))}
        </div>
        <div className="d-flex justify-content-start dirRes">
          <Button
            type="button"
            onClick={() => {
              window.location.reload("/");
              reserFilters();
              onHideMainModel();
              onHide();
              setShowFilterPropertyType(true);
            }}
          >
            {t("filter.reset")}
          </Button>
          <Button
            style={{ marginLeft: "10px" }}
            type="button"
            onClick={() => {
              onHide();
              setShowFilterPropertyType(true);
              onHideMainModel();
              dashboardData(1);
            }}
          >
            {t("filter.apply")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function AdvancedFilterModal(props) {
  const {
    filters,
    handleFilterChange,
    show,
    onHide,
    reserFilters,
    setdataLoading,
    setpropertyData,
    dashboardData,
    maxPrice,
    filterList = [],
    facilitiesTypes = [],
    showFilterType,
  } = props;
  const { t } = useTranslation();

  const handleGuestsChange = (type, value) => {
    handleFilterChange("guests", {
      ...filters.guests,
      [type]: value,
    });
  };
  const language = localStorage.getItem("language");

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modalWidth"
    >
      <Modal.Body
        tyle={{
          maxHeight: "calc(100vh - 210px)",
          overflowY: "auto",
        }}
      >
        <Icon
          icon="carbon:close-outline"
          fontSize={32}
          color={"#CF0000"}
          onClick={onHide}
          className="crossModal"
        />
        <h2 className="text-center">{t("filter.advancedFilter")} </h2>
        <div className="modal_Header">
          <h3>{t("filter.propertyType")}</h3>
          {/* <Link className="showAll">Show All</Link> */}
        </div>

        <div
          className={
            language === "he" ? "checkBoxes-rtl checkBoxes" : "checkBoxes"
          }
        >
          {filterList &&
            filterList.length > 0 &&
            filterList.map((item, index) => (
              <div key={`property-checkbox-${index}`} className="mb-3">
                <Form.Check
                  type="checkbox"
                  id={`property-checkbox-${index}`}
                  label={item.eng_title}
                  checked={filters?.propertyType?.includes(item?.id.toString())}
                  onChange={() =>
                    handleFilterChange(
                      "propertyType",
                      filters.propertyType.includes(item.id.toString())
                        ? filters.propertyType.filter(
                          (i) => i !== item.id.toString()
                        )
                        : [...filters.propertyType, item.id.toString()]
                    )
                  }
                  className="form-check"
                />
              </div>
            ))}
        </div>
        <div className="modal_Header">
          <h3>{t("filter.facilities")}</h3>
          {/* <Link className="showAll">Show All</Link> */}
        </div>
        <div
          className={
            language === "he" ? "checkBoxes-rtl checkBoxes" : "checkBoxes"
          }
        >
          {facilitiesTypes &&
            facilitiesTypes.length > 0 &&
            facilitiesTypes.map((item, index) => (
              <div key={`facilities-checkbox-${index}`} className="mb-3">
                <Form.Check
                  type="checkbox"
                  id={`facilities-checkbox-${index}`}
                  label={item.eng_title}
                  checked={filters?.facilities?.includes(item?.eng_title)}
                  onChange={() =>
                    handleFilterChange(
                      "facilities",
                      filters.facilities.includes(item.eng_title)
                        ? filters.facilities.filter(
                          (i) => i !== item?.eng_title
                        )
                        : [...filters.facilities, item?.eng_title]
                    )
                  }
                />
              </div>
            ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Areas/Zones/Cities</h3>
        </div>
        <Form.Control
          type="text"
          placeholder="Enter Areas/Zones/Cities"
          className="inputNormal"
          value={filters?.areas}
          onChange={(e) => handleFilterChange("areas", e.target.value)}
        ></Form.Control> */}
        <div className="modal_Header">
          <h3>{t("filter.bedrooms")}</h3>
        </div>
        <div className="radio-group">
          {options.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option?.label}
              value={option?.value}
              checked={filters?.bedrooms === option?.value}
              onChange={(e) => handleFilterChange("bedrooms", e.target.value)}
            />
          ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Bathrooms</h3>
        </div>
        <div className="radio-group">
          {options1.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option.value}
              checked={filters?.bathrooms === option?.value}
              onChange={(e) => handleFilterChange("bathrooms", e.target.value)}
            />
          ))}
        </div> */}
        <div className="modal_Header">
          <h3>{t("filter.guests")}</h3>
        </div>
        <div className="quBox">
          <div>
            <span>Adults</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={() => {
                    if (filters?.guests?.adults > 0) {
                      handleGuestsChange("adults", filters?.guests?.adults - 1);
                    }
                  }}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{filters?.guests?.adults}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("adults", filters?.guests?.adults + 1)
                  }
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>{t("filter.children")}</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={() => {
                    if (filters.guests.children) {
                      handleGuestsChange(
                        "children",
                        filters.guests.children - 1
                      );
                    }
                  }}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{filters?.guests?.children}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("children", filters.guests.children + 1)
                  }
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>{t("filter.pets")}</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={() => {
                    if (filters?.guests?.pets > 0) {
                      handleGuestsChange("pets", filters?.guests?.pets - 1);
                    }
                  }}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{filters?.guests?.pets}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={() =>
                    handleGuestsChange("pets", filters?.guests?.pets + 1)
                  }
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal_Header">
          <h3>{t("filter.price")}</h3>
        </div>
        <div className="reactSliderFlex">
          <ReactSlider
            className="horizontal-slider horizontal-slider1"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            value={filters?.priceRange}
            onChange={(newValues) =>
              handleFilterChange("priceRange", newValues)
            }
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            min={1}
            max={maxPrice.price_for_weekends || 1000}
          />
        </div>
        <div className="priceRangFlex">
          <div className="rangeControl">
            <h4>{t("filter.minimum")}</h4>
            <h5>${filters?.priceRange[0]}</h5>
          </div>
          <div className="rangeDivider"></div>
          <div className="rangeControl">
            <h4>{t("filter.maximum")}</h4>
            <h5>${filters?.priceRange[1]}</h5>
          </div>
        </div>
        <div className="modal_Header">
          <h3>{t("filter.rating")}</h3>
        </div>
        <div className="star-rating">
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              className={index < filters?.rating ? "star filled" : "star"}
              onClick={() => handleFilterChange("rating", index + 1)}
            >
              <Icon icon="ph:star-fill" />
            </span>
          ))}
        </div>
        <div className="d-flex justify-content-start gap-3">
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              reserFilters();
              onHide();
              showFilterType();
              setTimeout(() => {
                setdataLoading(true);
                setpropertyData([]);
                dashboardData(1);
              }, 500);
            }}
          >
            {t("filter.reset")}
          </Button>
          <Button
            type="button"
            onClick={() => {
              onHide();
              setdataLoading(true);
              setpropertyData([]);
              dashboardData(1);
            }}
          >
            {t("filter.apply")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default HomeScreen;
